import React from 'react';
import styled from 'styled-components';
import { StudentAd2Card } from "./ad2Card";
import { useTranslation } from "react-i18next";
import CognitiveChart from '../../components/cognitiveCharts/cognitiveCharts';
import DonutChart from '../../components/cognitiveCharts/donutChartCognitive';
import Loader from '../../components/loader/loader';
import { NotCompleteText } from './commonStyles';
// Container Styles
const SectionContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 10px;
  @media (max-width: 767px) {
    flex-direction: column;
    padding: 10px 0;
  }
`;

const ChartColumn = styled.div`
  width: ${(props) => props.$width};
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const CardsContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: flex-start;
  @media (max-width: 767px) {
    width: 100%;
  }
`;


const CognitiveAbilityContent = ({ data }) => {
  const { t } = useTranslation();
 

  return (
    <div style={{ margin: "0px", padding: "0px", marginTop: "20px", }}>
      <StudentAd2Card title={t("Cognitive Ability")} sm="12" lg="12">
        {data.state === "success" ? (
          <SectionContainer>
            <ChartColumn $width="70%">
              <CardsContainer>
                <CognitiveChart
                  overall={data?.data?.overview}
                  overview={data?.data?.interpretation_of_score}
                  data={data?.data?.knowledge_area} />
              </CardsContainer>
            </ChartColumn>
            <ChartColumn $width="30%">
              <CardsContainer>
                <DonutChart overview={data?.data?.overview}/>
              </CardsContainer>
            </ChartColumn>

          </SectionContainer>
        ) : (
          data.state === "loading" ? (
            <Loader />
          ) : (
            data.state === "noDataFound" ? (
              <NotCompleteText style={{textAlign:"center"}}>{t('Not Completed')}</NotCompleteText>
            ) : ("")
          )
        )}
      </StudentAd2Card>
    </div>

  );
};

export default CognitiveAbilityContent;

